import React from 'react';
import {useFetchLocations} from '../../hooks';
import {customCountriesFilter} from '../../utils/customCountriesFilter';
import {Select as OldSelect, SelectProps, SelectRefType} from '@guestapp/old-ui-kit';
import {Select as UiKitSelect} from '@chekin/guestapp-ui-kit';
import {SelectOption} from '@chekin/core';

type Props = Omit<SelectProps, 'options'> & {
  variant?: 'default' | 'airbnb';
};

const CountriesSelectInternal = (
  props: Props,
  ref: React.ForwardedRef<SelectRefType>,
) => {
  const {locationsAsOptions} = useFetchLocations();
  const {variant = 'default', ...rest} = props;

  if (variant === 'airbnb') {
    return (
      <UiKitSelect
        variant="airbnb"
        label={rest.label ?? ''}
        placeholder={rest.placeholder as string | undefined}
        options={locationsAsOptions as SelectOption[]}
        value={(rest.value ?? null) as SelectOption | null}
        onChange={option => rest.onChange?.(option, {action: 'select-option', option})}
        name={rest.name}
        disabled={rest.disabled || rest.isDisabled}
        error={typeof rest.error === 'string' ? rest.error : rest.error?.message}
      />
    );
  }

  return (
    <OldSelect
      {...rest}
      ref={ref}
      filterOption={customCountriesFilter}
      options={locationsAsOptions}
    />
  );
};

export const CountriesSelect = React.forwardRef(CountriesSelectInternal) as (
  props: Props & {ref?: React.ForwardedRef<SelectRefType>},
) => ReturnType<typeof CountriesSelectInternal>;
